import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";
import { formatDateToISO } from "../../utils/formatDateToISO.js";

// Get records of the service from a particular date till present date
// export const getRecordsForDay = createAsyncThunk(
//   "crm/getRecordsFromDate",
//   async (day, thunkAPI) => {
//     const state = thunkAPI.getState();
//     const serviceId = state.auth.userData.selectedServiceId;
//     try {
//       const response = await axiosInstance.get(
//         `/crm/get_records/?start_date=${day}`,
//         {
//           headers: {
//             // "X-Api-Key": "YA7NxysJ",
//             "company-id": serviceId,
//           },
//         }
//       );
//       console.log("getRecordsForDay", response.data);

//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue({
//         status: error.response?.status,
//         message: error.message,
//         details: error.response?.data.detail, // Залишаємо лише необхідні дані
//       });
//     }
//   }
// );

// Create record +
export const createRecord = createAsyncThunk(
  "crm/createRecord",
  async (recordData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/records/`,
        recordData
      );
      console.log("create record", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update record data => moved to cars slice
// export const updateRecordData = createAsyncThunk(
//   "crm/updateRecordData",
//   async (recordDataToUpdate, thunkAPI) => {
//     try {
//       const { recordId, ...recordDataToUpdateWithoutId } = recordDataToUpdate;

//       const response = await axiosNewApiInstance.patch(
//         `/api/v1/records/${recordId}/`,
//         recordDataToUpdateWithoutId,
//       );
//       console.log(response.data);

//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue({
//         status: error.response?.status,
//         message: error.message,
//         details: error.response?.data.detail, // Залишаємо лише необхідні дані
//       });
//     }
//   }
// );

// Get one record by ID +
export const getRecordById = createAsyncThunk(
  "crm/getRecordById",
  async (recordId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/${recordId}`
      );
      console.log("getRecordById", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//Get booking data a particular date (for ServiceBookingModal) +
export const getServiceDataForBooking = createAsyncThunk(
  "crm/getServiceDataForBooking",
  async (day, thunkAPI) => {
    try {
      const formattedDate = formatDateToISO(day);

      if (!formattedDate) {
        throw new Error("Invalid date format");
      }

      const response = await axiosNewApiInstance.get(
        `/api/v1/records/get_data_for_booking?date=${day}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create new service type in ServiceBookingModal
export const createServiceType = createAsyncThunk(
  "crm/createServiceType",
  async (serviceTypeData, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosInstance.post(
        `/crm/services/add`,
        serviceTypeData,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": serviceId,
          },
        }
      );
      console.log("createServiceType", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get planned visits for a planner table +
export const getPlannedVisits = createAsyncThunk(
  "crm/getPlannedVisits",
  async (day, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/get_planner_daily?date=${day}`
      );
      console.log("getPlannedVisits", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get monthly load for calendar +
export const getMonthlyLoad = createAsyncThunk(
  "crm/getMonthlyLoad",
  async (month, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/records/get_calendar_load/?month_year=${month}`,
        {
          headers: {
            // "X-Api-Key": "YA7NxysJ",
            "company-id": serviceId,
          },
        }
      );
      console.log("response data", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get car data by license plate
export const getCarByLicensePlate = createAsyncThunk(
  "cars/getCarByLicensePlate",
  async (plate, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/vehicles/search_vehicle?plate=${plate}`,
        null
      );
      console.log("getCarByLicensePlate", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
